const pages_buy_buyer = () => import('~/pages/buy/buyer');
const pages_buy_buyer_detail = () => import('~/pages/buy/buyer_detail');
const pages_buy_cbuyer = () => import('~/pages/buy/cbuyer');
const pages_buy_qfr_line = () => import('~/pages/buy/qfr_line_v1');
const pages_buy_business_link = () => import('~/pages/buy/business_link');
// const pages_buy_qfr_line_detail = () => import("~/pages/buy/qfr_line_detail")
const pages_buy_qfr_list = () => import('~/pages/buy/qfr_list');
const pages_buy_qfr_list_detail = () => import('~/pages/buy/qfr_list_detail');
const pages_buy_biz_line = () => import('~/pages/buy/biz_line');
const pages_cart_biz_line = () => import('~/pages/cart/biz_line');

const pages_buy_rfq_line = () => import('~/pages/buy/rfq_line_v1');
// const pages_buy_rfq_line_detail = () => import("~/pages/buy/rfq_line_detail")
const pages_buy_match_workbench = () => import('~/pages/buy/match_workbench');
const pages_buy_rfq_list = () => import('~/pages/buy/rfq_list');
const pages_buy_rfq_list_detail = () => import('~/pages/buy/rfq_list_detail');
const pages_buy_sales_order_list = () => import('~/pages/buy/sales_order_list');
const pages_buy_sales_order_line = () => import('~/pages/buy/sales_order_line');
const pages_buy_sales_order_line_v1 = () => import('~/pages/buy/sales_order_line_v1');
const pages_return_return_request_line = () => import('~/pages/return/return_request_line');
const pages_return_return_request_detail = () => import('~/pages/return/return_request_detail');
const pages_buy_sales_match_line = () => import('~/pages/buy/sales_match_line');
const pages_buy_purchasing_rfq_line = () => import('~/pages/buy/purchasing_rfq_line');
const pages_buy_management_rfq_line = () => import('~/pages/buy/management_rfq_line');
const pages_buy_smart_query = () => import('~/pages/buy/smart_query');
const pages_buy_grouping_buy = () => import('~/pages/sell/grouping_buy');
const pages_buy_purchase_order_list = () => import('~/pages/sell/purchase_order_list');
const pages_buy_purchase_order_line = () => import('~/pages/sell/purchase_order_line_v1');
const pages_cart_coupon = () => import('~/pages/cart/coupon');
const pages_cart_exchange = () => import('~/pages/cart/exchange');
const pages_cart_listings = () => import('~/pages/cart/listings');
const pages_cart_point = () => import('~/pages/cart/point');
const pages_cart_spu_index = () => import('~/pages/cart/spu/index');
const pages_cart_spu_spu_detail = () => import('~/pages/cart/spu/spu_detail');
const pages_cart_product = () => import('~/pages/cart/product');
// const pages_cart_workbench = () => import("~/pages/cart/workbench")
const pages_work_board_index = () => import("~/pages/work-board/index");
const pages_cart_trading_basket = () => import("~/pages/cart/trading_basket")
const pages_cart_business_desk = () => import("~/pages/cart/business_desk")
const pages_cart_checkout_account = () => import("~/pages/cart/checkout_account")
const pages_cart_prompt_account = () => import("~/pages/cart/prompt_account")
const pages_cart_advance_account = () => import("~/pages/cart/advance_account")
const pages_cart_order_trail = () => import("~/pages/cart/order_trail")
const pages_erp_account_account_buyer = () => import("~/pages/erp/account/account/buyer")
const pages_erp_account_account_finance = () => import("~/pages/erp/account/account/finance")
const pages_erp_account_account_info = () => import("~/pages/erp/account/account/info")
const pages_erp_account_account_management = () => import("~/pages/erp/account/account/management")
const pages_erp_account_account_recycle = () => import("~/pages/erp/account/account/recycle")
const pages_erp_account_account_appointment = () => import("~/pages/erp/account/account/appointment")
const pages_erp_account_account_main = () => import("~/pages/erp/account/account/main")
const pages_erp_account_account_seller = () => import("~/pages/erp/account/account/seller")
const pages_erp_account_agreement_signature = () => import("~/pages/erp/account/agreement/signature")
const pages_erp_account_agreement_version = () => import("~/pages/erp/account/agreement/version")
const pages_erp_account_bank_account = () => import("~/pages/erp/account/bank/account")
const pages_erp_account_bank_info = () => import("~/pages/erp/account/bank/info")
const pages_erp_account_bank_bank= () => import("~/pages/erp/account/bank/bank")
const pages_erp_account_bank_bank_account = () => import("~/pages/erp/account/bank/bank_account")
const pages_erp_account_contact_info = () => import("~/pages/erp/account/contact/info")
const pages_erp_account_contact_member = () => import("~/pages/erp/account/contact/member")
const pages_erp_account_credit_info = () => import("~/pages/erp/account/credit/info")
const pages_erp_account_credit_manage = () => import("~/pages/erp/account/credit/manage")
const pages_erp_account_credit_verification = () => import("~/pages/erp/account/credit/verification")
const pages_erp_account_invoice_info = () => import("~/pages/erp/account/invoice/info")
const pages_erp_account_invoice_tax = () => import("~/pages/erp/account/invoice/tax")
const pages_erp_accouting_account_analysis = () => import("~/pages/erp/accouting/account/analysis")
const pages_erp_accouting_account_code = () => import("~/pages/erp/accouting/account/code")
const pages_erp_accouting_legalEntity = () => import("~/pages/erp/account/account/legalEntity")
const pages_erp_accouting_bill_ledger = () => import("~/pages/erp/accouting/bill/ledger")
const pages_erp_accouting_bill_payable = () => import("~/pages/erp/accouting/bill/payable")
const pages_erp_accouting_bill_receivable = () => import("~/pages/erp/accouting/bill/receivable")
const pages_erp_accouting_order_purchasing_line = () => import("~/pages/erp/accouting/order/purchasing/line")
const pages_erp_accouting_order_purchasing_po = () => import("~/pages/erp/accouting/order/purchasing/po")
const pages_erp_accouting_order_purchasing_prma = () => import("~/pages/erp/accouting/order/purchasing/prma")
const pages_erp_accouting_order_sales_line = () => import("~/pages/erp/accouting/order/sales/line")
const pages_erp_accouting_order_sales_so = () => import("~/pages/erp/accouting/order/sales/so")
const pages_erp_accouting_order_sales_srma = () => import("~/pages/erp/accouting/order/sales/srma")
const pages_erp_accouting_payment_incoming = () => import("~/pages/erp/accouting/payment/incoming")
const pages_erp_accouting_payment_outgoing = () => import("~/pages/erp/accouting/payment/outgoing")
const pages_erp_accouting_report_index = () => import("~/pages/erp/accouting/report/index")
const pages_erp_accouting_tax_input = () => import("~/pages/erp/accouting/tax/input")
const pages_erp_accouting_tax_output = () => import("~/pages/erp/accouting/tax/output")
const pages_erp_credit_contact_contactperson_index = () => import("~/pages/erp/credit/contact/contactperson/index")
const pages_erp_credit_contact_index = () => import("~/pages/erp/credit/contact/index")
const pages_erp_credit_contact_info = () => import("~/pages/erp/credit/contact/info")
const pages_erp_credit_contact_legalperson_index = () => import("~/pages/erp/credit/contact/legalperson/index")
const pages_erp_credit_contact_naturalperson_index = () => import("~/pages/erp/credit/contact/naturalperson/index")
const pages_erp_credit_contact_relationship = () => import("~/pages/erp/credit/contact/relationship")
const pages_erp_credit_contact_shop_index = () => import("~/pages/erp/credit/contact/shop/index")
const pages_erp_credit_contact_user_index = () => import("~/pages/erp/credit/contact/user/index")
const pages_erp_credit_credit_info = () => import("~/pages/erp/credit/credit/info")
const pages_erp_credit_credit_verification = () => import("~/pages/erp/credit/credit/verification")
const pages_erp_credit_legal_certificate = () => import("~/pages/erp/credit/legal/certificate")
const pages_erp_credit_legal_info = () => import("~/pages/erp/credit/legal/info")
const pages_erp_credit_natural_certificate = () => import("~/pages/erp/credit/natural/certificate")
const pages_erp_credit_natural_experience = () => import("~/pages/erp/credit/natural/experience")
const pages_erp_credit_natural_info = () => import("~/pages/erp/credit/natural/info")
const pages_erp_index = () => import("~/pages/erp/index")
const pages_erp_market_activity = () => import("~/pages/erp/market/activity")
const pages_erp_market_contact_contactperson_index = () => import("~/pages/erp/market/contact/contactperson/index")
const pages_erp_market_contact_index = () => import("~/pages/erp/market/contact/index")
const pages_erp_market_contact_info = () => import("~/pages/erp/market/contact/info")
const pages_erp_market_contact_legalperson_index = () => import("~/pages/erp/market/contact/legalperson/index")
const pages_erp_market_contact_naturalperson_index = () => import("~/pages/erp/market/contact/naturalperson/index")
const pages_erp_market_contact_relationship = () => import("~/pages/erp/market/contact/relationship")
const pages_erp_market_contact_shop_index = () => import("~/pages/erp/market/contact/shop/index")
const pages_erp_market_contact_user_index = () => import("~/pages/erp/market/contact/user/index")
const pages_erp_market_content = () => import("~/pages/erp/market/content")
const pages_erp_market_credit_info = () => import("~/pages/erp/market/credit/info")
const pages_erp_market_credit_verification = () => import("~/pages/erp/market/credit/verification")
const pages_erp_market_invite = () => import("~/pages/erp/market/invite")
const pages_erp_market_legal_certificate = () => import("~/pages/erp/market/legal/certificate")
const pages_erp_market_legal_info = () => import("~/pages/erp/market/legal/info")
const pages_erp_market_natural_certificate = () => import("~/pages/erp/market/natural/certificate")
const pages_erp_market_natural_experience = () => import("~/pages/erp/market/natural/experience")
const pages_erp_market_natural_info = () => import("~/pages/erp/market/natural/info")
const pages_erp_operation_attendance = () => import("~/pages/erp/operation/attendance")
const pages_erp_operation_budget = () => import("~/pages/erp/operation/budget")
const pages_erp_operation_department = () => import("~/pages/erp/operation/department")
const pages_erp_operation_employee = () => import("~/pages/erp/operation/employee")
const pages_erp_operation_job = () => import("~/pages/erp/operation/job")
const pages_erp_operation_kpi = () => import("~/pages/erp/operation/kpi")
const pages_erp_operation_policy = () => import("~/pages/erp/operation/policy")
const pages_erp_operation_position = () => import("~/pages/erp/operation/position")
const pages_erp_operation_report = () => import("~/pages/erp/operation/report")
const pages_erp_operation_salary = () => import("~/pages/erp/operation/salary")
const pages_erp_portal_business = () => import("~/pages/erp/portal/business")
const pages_erp_portal_contract = () => import("~/pages/erp/portal/contract")
const pages_erp_portal_data = () => import("~/pages/erp/portal/data")
const pages_erp_portal_external_partner = () => import("~/pages/erp/portal/external_partner")
const pages_erp_portal_grant_position = () => import("~/pages/erp/portal/grant/position")
const pages_erp_portal_grant_privilege = () => import("~/pages/erp/portal/grant/privilege")
const pages_erp_portal_grant_default_station = () => import("~/pages/erp/portal/grant/default_station")
const pages_erp_portal_organization_department = () => import("~/pages/erp/portal/organization/department")
const pages_erp_portal_organization_station = () => import("~/pages/erp/portal/organization/station")
const pages_erp_portal_organization_appoint = () => import("~/pages/erp/portal/organization/appoint")
const pages_erp_portal_internal_partner = () => import("~/pages/erp/portal/internal_partner")
const pages_erp_portal_manage = () => import("~/pages/erp/portal/manage")
const pages_erp_portal_quota = () => import("~/pages/erp/portal/quota")
const pages_erp_portal_service = () => import("~/pages/erp/portal/service")
const pages_erp_portal_settlement = () => import("~/pages/erp/portal/settlement")
const pages_erp_service_shop_index = () => import("~/pages/erp/service/shop/index")
const pages_erp_portal_shop_management_detail = () => import("~/pages/erp/portal/shop/management/detail")
const pages_erp_portal_shop_management_index = () => import("~/pages/erp/portal/shop/management/index")
const pages_erp_portal_shop_member_detail = () => import("~/pages/erp/portal/shop/member/detail")
const pages_erp_portal_shop_member_index = () => import("~/pages/erp/portal/shop/member/index")
const pages_erp_portal_shop_register_detail = () => import("~/pages/erp/portal/shop/register/detail")
const pages_erp_portal_shop_register_index = () => import("~/pages/erp/portal/shop/register/index")
const pages_erp_portal_tenant = () => import("~/pages/erp/portal/tenant")
const pages_erp_portal_user_management_detail = () => import("~/pages/erp/portal/user/management/detail")
const pages_erp_portal_user_management_index = () => import("~/pages/erp/portal/user/management/index")
const pages_erp_portal_user_register_index = () => import("~/pages/erp/portal/user/register/index")
const pages_erp_portal_website = () => import("~/pages/erp/portal/website")
const pages_erp_portal_whitepaper = () => import("~/pages/erp/portal/whitepaper")
const pages_erp_product_attribute_attribute = () => import("~/pages/erp/product/attribute/attribute")
const pages_erp_product_attribute_eccn = () => import("~/pages/erp/product/attribute/eccn")
const pages_erp_product_attribute_hscode = () => import("~/pages/erp/product/attribute/hscode")
const pages_erp_product_attribute_info = () => import("~/pages/erp/product/attribute/info")
const pages_erp_product_attribute_package = () => import("~/pages/erp/product/attribute/package")
const pages_erp_product_brand_authorization = () => import("~/pages/erp/product/brand/authorization")
const pages_erp_product_brand_business_report = () => import("~/pages/erp/product/brand/business_report")
const pages_erp_product_brand_info = () => import("~/pages/erp/product/brand/info")
const pages_erp_product_brand_info_report = () => import("~/pages/erp/product/brand/info_report")
const pages_erp_product_brand_management = () => import("~/pages/erp/product/brand/management")
const pages_erp_product_category_business_report = () => import("~/pages/erp/product/category/business_report")
const pages_erp_product_category_info = () => import("~/pages/erp/product/category/info")
const pages_erp_product_category_info_report = () => import("~/pages/erp/product/category/info_report")
const pages_erp_product_category_management = () => import("~/pages/erp/product/category/management")
const pages_erp_product_price_cost = () => import("~/pages/erp/product/price/cost")
const pages_erp_product_price_listpriceline = () => import("~/pages/erp/product/price/listpriceline")
const pages_erp_product_price_list_price = () => import("~/pages/erp/product/price/list_price")
const pages_erp_product_price_policy = () => import("~/pages/erp/product/price/policy")
const pages_erp_product_price_price_list = () => import("~/pages/erp/product/price/price_list")
const pages_erp_product_price_price_rule = () => import("~/pages/erp/product/price/price_rule")
const pages_erp_product_price_quote = () => import("~/pages/erp/product/price/quote")
const pages_erp_product_report_index = () => import("~/pages/erp/product/report/index")
const pages_erp_product_specification_code = () => import("~/pages/erp/product/specification/code")
const pages_erp_product_specification_detail = () => import("~/pages/erp/product/specification/detail")
const pages_erp_product_specification_info = () => import("~/pages/erp/product/specification/info")
const pages_erp_product_specification_report = () => import("~/pages/erp/product/specification/report")
const pages_erp_product_specification_sku = () => import("~/pages/erp/product/specification/sku")
const pages_erp_product_spu_business_report = () => import("~/pages/erp/product/spu/business_report")
const pages_erp_product_spu_info = () => import("~/pages/erp/product/spu/info")
const pages_erp_product_spu_info_report = () => import("~/pages/erp/product/spu/info_report")
const pages_erp_product_spu_management = () => import("~/pages/erp/product/spu/management")
const pages_erp_product_spu_qualified_vendor_management = () => import("~/pages/erp/product/spu_qualified_vendor/management")
const pages_erp_product_spu_qualified_vendor_shopspu = () => import("~/pages/erp/product/spu_qualified_vendor/shopspu")
const pages_erp_product_spu_qualified_vendor_brandlist = () => import("~/pages/erp/product/spu_qualified_vendor/brandlist")
const pages_erp_product_workbench_index = () => import("~/pages/erp/product/workbench/index")
const pages_erp_service_activity = () => import("~/pages/erp/service/activity")
const pages_erp_service_arrachments_index = () => import("~/pages/erp/service/arrachments/index")
const pages_erp_service_chat = () => import("~/pages/erp/service/chat")
const pages_erp_service_comments_index = () => import("~/pages/erp/service/comments/index")
const pages_erp_service_currency = () => import("~/pages/erp/service/currency")
const pages_erp_service_keyword = () => import("~/pages/erp/service/keyword")
const pages_erp_staff_dashboard_index = () => import("~/pages/erp/staff/dashboard/index")
const pages_erp_service_dictionary = () => import("~/pages/erp/service/indexer/dictionary")
const pages_erp_service_indexer = () => import("~/pages/erp/service/indexer/indexer")
const pages_erp_service_entity = () => import("~/pages/erp/service/indexer/entity")
const pages_erp_service_field = () => import("~/pages/erp/service/indexer/field")
const pages_erp_service_region = () => import("~/pages/erp/service/indexer/region")
const pages_erp_service_interface = () => import("~/pages/erp/service/indexer/interface")
const pages_erp_service_word = () => import("~/pages/erp/service/indexer/word")
const pages_erp_service_favorites_index = () => import("~/pages/erp/service/favorites/index")
const pages_erp_service_language = () => import("~/pages/erp/service/language")
const pages_erp_service_list_mapping_column = () => import("~/pages/erp/service/list_mapping/column")
const pages_erp_service_list_mapping_field = () => import("~/pages/erp/service/list_mapping/field")
const pages_erp_service_mapping_account = () => import("~/pages/erp/service/mapping/account")
const pages_erp_service_mapping_interchange = () => import("~/pages/erp/service/mapping/interchange")
const pages_erp_service_mapping_monitor = () => import("~/pages/erp/service/mapping/monitor")
const pages_erp_service_ratings_index = () => import("~/pages/erp/service/ratings/index")
const pages_erp_service_remark = () => import("~/pages/erp/service/remark")
const pages_erp_service_tag = () => import("~/pages/erp/service/tag")
const pages_erp_service_tags_index = () => import("~/pages/erp/service/tags/index")
const pages_erp_service_tax = () => import("~/pages/erp/service/tax")
const pages_erp_service_reporting_metrics_index = () => import("~/pages/erp/service/reporting/metrics/index")
const pages_erp_service_reporting_dimension_index = () => import("~/pages/erp/service/reporting/dimension/index")
const pages_erp_service_reporting_kpi_index = () => import("~/pages/erp/service/reporting/kpi/index")
const pages_erp_service_reporting_dashboard_index = () => import("~/pages/erp/service/reporting/dashboard/index")
const pages_erp_service_services_item_index = () => import("~/pages/erp/service/services_item/index")
const pages_erp_service_time_zone = () => import("~/pages/erp/service/time_zone")
const pages_erp_service_manage_print = () => import("~/pages/erp/service/manage/print")
const pages_erp_service_manage_api = () => import("~/pages/erp/service/manage/api")
const pages_erp_service_manage_access = () => import("~/pages/erp/service/manage/access")
const pages_erp_service_manage_site = () => import("~/pages/erp/service/manage/site")
const pages_erp_service_manage_menu = () => import("~/pages/erp/service/manage/menu")
const pages_erp_service_manage_site_template = () => import("~/pages/erp/service/manage/site_template")
const pages_erp_service_manage_domain = () => import("~/pages/erp/service/manage/domain")
const pages_erp_service_engine_rule = () => import("~/pages/erp/service/engine/rule")
const pages_erp_service_engine_policy = () => import("~/pages/erp/service/engine/policy")

const pages_erp_shipping_customs_declaration = () => import("~/pages/erp/shipping/customs_declaration")
const pages_erp_shipping_packing_list = () => import("~/pages/erp/shipping/packing_list")
const pages_erp_shipping_qc = () => import("~/pages/erp/shipping/qc")
const pages_erp_shipping_report = () => import("~/pages/erp/shipping/report")
const pages_erp_shipping_sort = () => import("~/pages/erp/shipping/sort")
const pages_erp_shipping_test_sheet = () => import("~/pages/erp/shipping/test_sheet")
const pages_erp_shipping_warehouse = () => import("~/pages/erp/shipping/warehouse")
const pages_erp_shipping_warehouse_receipt = () => import("~/pages/erp/shipping/warehouse_receipt")
const pages_erp_shipping_waybill = () => import("~/pages/erp/shipping/waybill")
const pages_export_match = () => import("~/pages/export/match")
const pages_home_index = () => import("~/pages/home/index")
const pages_hub_bom = () => import("~/pages/hub/bom")
const pages_hub_history = () => import("~/pages/hub/history")
const pages_hub_history_info = () => import("~/pages/hub/history_info")
const pages_hub_hub = () => import("~/pages/hub/hub")
const pages_hub_match = () => import("~/pages/hub/match")
const pages_hub_result = () => import("~/pages/hub/result")
const pages_hub_upload = () => import("~/pages/hub/uploadNew")
const pages_index = () => import("~/pages/index")
const pages_info_account_index = () => import("~/pages/info/account/index")
const pages_info_member_account = () => import("~/pages/info/memberAccount")
const pages_info_account_contact_detail = () => import("~/pages/info/account_contact_detail")
const pages_info_account_invoice_detail = () => import("~/pages/info/account_invoice_detail")
const pages_info_article = () => import("~/pages/info/article")
const pages_info_attachment = () => import("~/pages/info/attachment")
const pages_info_bank_detail = () => import("~/pages/info/bank_detail")
const pages_info_comment = () => import("~/pages/info/comment")
const pages_info_contact = () => import("~/pages/info/contact")
const pages_info_contact_single = () => import('~/pages/info/contact_single')
const pages_info_contact_detail = () => import("~/pages/info/contact_detail")
const pages_info_home = () => import("~/pages/info/home")
const pages_info_invitation = () => import("~/pages/info/invitation")
const pages_info_member = () => import("~/pages/info/member")
const pages_info_account_contact = () => import("~/pages/info/account_contact")
const pages_info_partner_shop = () => import("~/pages/info/partner_shop")
const pages_info_collect_shop = () => import("~/pages/info/collect_shop")
const pages_info_folder = () => import("~/pages/info/folder")

const pages_info_member_detail = () => import("~/pages/info/member_detail")
const pages_info_setting = () => import("~/pages/info/setting")
const pages_info_price_rule = () => import("~/pages/info/price_rule")
const pages_info_profile = () => import("~/pages/info/profile")
const pages_info_dashboard = () => import("~/pages/info/dashboard")
const pages_info_section = () => import("~/pages/info/section")
const pages_info_station = () => import("~/pages/info/station")
const pages_info_station_detail = () => import("~/pages/info/station_detail")
const pages_info_notification = () => import("~/pages/info/notification")
const pages_login_login = () => import("~/pages/login/login")
const pages_login_retrieve_password = () => import("~/pages/login/retrieve_password")
const pages_order_buy_car = () => import('~/pages/order/buy_car');
const pages_order_sell_car = () => import('~/pages/order/sell_car');
const pages_order_payment = () => import('~/pages/order/payment');
const pages_order_payment_result = () => import('~/pages/order/payment_result');
const pages_order_payment_flow = () => import('~/pages/order/payment_flow');
const pages_order_arbitration = () => import('~/pages/order/arbitration');
const pages_order_sale_bill = () => import('~/pages/order/sale_bill');
const pages_order_sale_item = () => import('~/pages/order/sale_item');
const pages_order_sale_return = () => import('~/pages/order/sale_return');
const pages_sale_tax_receipt = () => import('~/pages/order/sale_tax_receipt');
const pages_sale_shipments = () => import('~/pages/order/sale_shipments');
const pages_cfo_payment = () => import('~/pages/order/cfo_payment');
const pages_cfo_payment_outbound = () => import('~/pages/order/cfo_payment_outbound');

const pages_purchase_tax_receipt = () => import('~/pages/order/purchase_tax_receipt');
const pages_order_customer_order = () => import('~/pages/order/customer_order');
const pages_order_purchase_bill = () => import('~/pages/order/purchase_bill');
const pages_order_purchase_item = () => import('~/pages/order/purchase_item');
const pages_order_purchase_return = () => import('~/pages/order/purchase_return');
const pages_order_provider_order = () => import('~/pages/order/provider_order');
const pages_order_allotment_receipt = () => import('~/pages/order/allotment_receipt');
const pages_order_allotment_receive = () => import('~/pages/order/allotment_receive');
const pages_password = () => import("~/pages/password")
const pages_register = () => import("~/pages/register")
const pages_login = () => import("~/pages/login")
const pages_search_index = () => import("~/pages/search/index")
const pages_sell_avab_line = () => import('~/pages/sell/avab_line_v1');
// const pages_sell_avab_line_detail = () => import("~/pages/sell/avab_line_detail")
const pages_sell_avab_list = () => import('~/pages/sell/avab_list');
const pages_sell_avab_list_detail = () => import('~/pages/sell/avab_list_detail');
const pages_sell_qfa_line = () => import('~/pages/sell/qfa_line');
// const pages_sell_qfa_line_detail = () => import("~/pages/sell/qfa_line_detail")
const pages_sell_qfa_list = () => import('~/pages/sell/qfa_list');
const pages_sell_seller = () => import('~/pages/sell/seller');
const pages_sell_seller_detail = () => import('~/pages/sell/seller_detail');
const pages_sell_sku = () => import('~/pages/sell/sku');
const pages_sell_sku_detail = () => import('~/pages/sell/sku_detail');
const pages_spu_index = () => import("~/pages/spu/index")
const pages_spu_list = () => import("~/pages/spu/spu_list")
const pages_spu_detail = () => import("~/pages/spu/spu_detail")
const pages_spu_super_table = () => import("~/pages/spu/super_table")
const pages_user_articles = () => import("~/pages/user/articles")
const pages_user_bind = () => import("~/pages/user/bind")
const pages_user_info = () => import("~/pages/user/info")
const pages_user_shop = () => import("~/pages/user/shop")
const pages_user_wallet = () => import('~/pages/user/wallet');
const pages_user_notification = () => import("~/pages/user/notification")
const pages_user_activity = () => import("~/pages/user/activity")
const pages_user_sound = () => import("~/pages/info/sound")
const pages_user_dashboard = () => import("~/pages/info/dashboardPoster")
const layout_default = () => import("~/layouts/default")
const layout_admin = () => import("~/layouts/admin")
const pages_erp_account_user = () => import("~/pages/erp/account/account/user")
const pages_erp_account_shop = () => import("~/pages/erp/account/account/shop")
const pages_erp_logistics_order = () => import("~/pages/erp/logistics/picking/order/index")
const pages_erp_logistics_order_line = () => import("~/pages/erp/logistics/picking/order/order_line")
const pages_erp_logistics_receipt = () => import("~/pages/erp/logistics/picking/receipt/index")
const pages_erp_logistics_receipt_line = () => import("~/pages/erp/logistics/picking/receipt/receipt_line")
const pages_erp_logistics_put_in_storage = () => import("~/pages/erp/logistics/picking/put_in_storage/index")
const pages_erp_logistics_put_in_storage_line = () => import("~/pages/erp/logistics/picking/put_in_storage/put_in_storage_line")
const pages_erp_logistics_ex_warehouse = () => import("~/pages/erp/logistics/picking/ex_warehouse/index")
const pages_erp_logistics_ex_warehouse_line = () => import("~/pages/erp/logistics/picking/ex_warehouse/ex_warehouse_line")
const pages_erp_logistics_shipments = () => import("~/pages/erp/logistics/picking/shipments/index")
const pages_erp_logistics_shipments_line = () => import("~/pages/erp/logistics/picking/shipments/shipments_line")
const pages_erp_logistics_service_line = () => import("~/pages/erp/logistics/picking/service_line/index")
const pages_erp_logistics_waybill = () => import("~/pages/erp/logistics/transport/waybill")
const pages_erp_logistics_packing_list = () => import("~/pages/erp/logistics/transport/packing_list")
const pages_erp_logistics_packing_item = () => import("~/pages/erp/logistics/transport/packing_item")
const pages_erp_logistics_tariff = () => import("~/pages/erp/logistics/transport/tariff")
const pages_erp_logistics_tariff_line = () => import("~/pages/erp/logistics/transport/tariff_line")
const pages_erp_logistics_carriers = () => import("~/pages/erp/logistics/transport/carriers")
const pages_erp_logistics_shipping_method = () => import("~/pages/erp/logistics/transport/shipping_method")
const pages_erp_logistics_tariff_filing = () => import("~/pages/erp/logistics/transport/tariff_filing")
const pages_erp_logistics_quality_qc_test = () => import("~/pages/erp/logistics/quality/qc_test")
const pages_erp_logistics_quality_qc_report = () => import("~/pages/erp/logistics/quality/qc_report")
const pages_erp_logistics_quality_qc_categ = () => import("~/pages/erp/logistics/quality/qc_categ")
const pages_erp_logistics_quality_qc_rule = () => import("~/pages/erp/logistics/quality/qc_rule")
const pages_erp_logistics_quality_qc_sample = () => import("~/pages/erp/logistics/quality/qc_sample")
const pages_erp_logistics_store_keeper_moving = () => import("~/pages/erp/logistics/store_keeper/moving")
const pages_erp_logistics_store_keeper_moving_line = () => import("~/pages/erp/logistics/store_keeper/moving_line")
const pages_erp_logistics_store_keeper_stock_check = () => import("~/pages/erp/logistics/store_keeper/stock_check")
const pages_erp_logistics_store_keeper_stock_check_line = () => import("~/pages/erp/logistics/store_keeper/stock_check_line")
const pages_erp_logistics_warehousing_stock = () => import("~/pages/erp/logistics/warehousing/stock")
const pages_erp_logistics_warehousing_stock_line = () => import("~/pages/erp/logistics/warehousing/stock_line")
const pages_erp_logistics_warehousing_warehouse_receipt = () => import("~/pages/erp/logistics/warehousing/warehouse_receipt")
const pages_erp_logistics_warehousing_warehouse_receipt_item = () => import("~/pages/erp/logistics/warehousing/warehouse_receipt_item")
const pages_erp_logistics_warehousing_scheduling = () => import("~/pages/erp/logistics/warehousing/scheduling")
const pages_erp_logistics_warehousing_packing_box = () => import("~/pages/erp/logistics/warehousing/packing_box")
const pages_erp_logistics_warehousing_packaging = () => import("~/pages/erp/logistics/warehousing/packaging")
const pages_erp_logistics_reservoir_area_warehouse = () => import("~/pages/erp/logistics/reservoir_area/warehouse")
const pages_erp_logistics_reservoir_area_section = () => import("~/pages/erp/logistics/reservoir_area/section")
const pages_erp_logistics_reservoir_area_lot = () => import("~/pages/erp/logistics/reservoir_area/lot")
const pages_erp_logistics_tracking_no = () => import("~/pages/erp/logistics/reservoir_area/tracking_no")
const pages_erp_logistics_layout = () => import("~/pages/erp/logistics/reservoir_area/layout")
const pages_erp_logistics_channel = () => import("~/pages/erp/logistics/reservoir_area/channel")
const pages_erp_logistics_path = () => import("~/pages/erp/logistics/reservoir_area/path")
const pages_erp_logistics_type = () => import("~/pages/erp/logistics/reservoir_area/type")
const pages_erp_logistics_tenement = () => import("~/pages/erp/logistics/management/tenement")
const pages_erp_logistics_connected_group = () => import("~/pages/erp/logistics/management/connected_group")
const pages_erp_logistics_traders = () => import("~/pages/erp/logistics/management/traders")
const pages_erp_logistics_contacts = () => import("~/pages/erp/logistics/management/contacts")
const pages_erp_logistics_work_order = () => import("~/pages/erp/logistics/management/work_order")
const pages_erp_logistics_work_order_item = () => import("~/pages/erp/logistics/management/work_order_item")
const pages_erp_logistics_expense = () => import("~/pages/erp/logistics/management/expense")
const pages_erp_logistics_expense_item = () => import("~/pages/erp/logistics/management/expense_item")
// const pages_protal_spu = () => import("~/pages/portal/spu")
// const pages_protal_brand = () => import("~/pages/portal/brand")
// const pages_protal_category = () => import("~/pages/portal/category")
// const pages_protal_content = () => import("~/pages/portal/content")

// const preUrl = '/forward'
const pages_erp_product_product_brand = () => import('~/pages/erp/product/product/brand');
const pages_erp_product_product_spu = () => import('~/pages/erp/product/product/spu');
const pages_erp_product_product_brand_report = () => import('~/pages/erp/product/product/brand_report');
const pages_erp_product_product_spu_report = () => import('~/pages/erp/product/product/spu_report');
const pages_erp_product_product_fmt = () => import('~/pages/erp/product/product/fmt');
const pages_erp_product_product_detail = () => import('~/pages/erp/product/product/detail');
const pages_erp_product_product_apl = () => import('~/pages/erp/product/product/apl');
const pages_erp_product_product_attribute = () => import('~/pages/erp/product/product/attribute');
const pages_erp_product_product_eccn = () => import('~/pages/erp/product/product/eccn');
const pages_erp_product_product_hscode = () => import('~/pages/erp/product/product/hscode');
const pages_erp_product_product_category = () => import('~/pages/erp/product/product/category');
const pages_erp_product_product_package = () => import('~/pages/erp/product/product/package');
const pages_erp_service_history_index = () => import('~/pages/erp/service/history/index');

const pages_erp_finance_receivable_customer = () => import("~/pages/erp/finance/receivable/customer")
const pages_erp_finance_receivable_cfo_invoice_line = () => import("~/pages/erp/finance/receivable/cfo_invoice_line")
const pages_erp_finance_receivable_cfo_invoice = () => import("~/pages/erp/finance/receivable/cfo_invoice")
const pages_erp_finance_receivable_cfo_payment = () => import("~/pages/erp/finance/receivable/cfo_payment")
const pages_erp_finance_receivable_cfo_write_off = () => import("~/pages/erp/finance/receivable/cfo_write_off")
const pages_erp_finance_receivable_cfo_tax_receipt = () => import("~/pages/erp/finance/receivable/cfo_tax_receipt")
const pages_erp_finance_receivable_cfo_tax_receipt_line = () => import("~/pages/erp/finance/receivable/cfo_tax_receipt_line")
const pages_erp_finance_receivable_cfo_invoice_expense = () => import("~/pages/erp/finance/receivable/cfo_invoice_expense")
const pages_erp_finance_receivable_cfo_invoice_line_expense = () => import("~/pages/erp/finance/receivable/cfo_invoice_line_expense")

const pages_erp_finance_payable_vendor= () => import("~/pages/erp/finance/payable/vendor")
const pages_erp_finance_payable_cfo_invoice_outbound= () => import("~/pages/erp/finance/payable/cfo_invoice_outbound")
const pages_erp_finance_payable_cfo_invoice_line_outbound= () => import("~/pages/erp/finance/payable/cfo_invoice_line_outbound")
const pages_erp_finance_payable_cfo_payment_outbound= () => import("~/pages/erp/finance/payable/cfo_payment_outbound")
const pages_erp_finance_payable_cfo_write_off_outbound= () => import("~/pages/erp/finance/payable/cfo_write_off_outbound")
const pages_cart_buy_sell= () => import("~/pages/cart/buy_sell")
const pages_cart_sell= () => import("~/pages/cart/sell")
const pages_cart_price= () => import("~/pages/cart/price")
const pages_erp_finance_payable_cfo_tax_receipt_outbound = () => import("~/pages/erp/finance/payable/cfo_tax_receipt_outbound")
const pages_erp_finance_payable_cfo_tax_receipt_line_outbound = () => import("~/pages/erp/finance/payable/cfo_tax_receipt_line_outbound")
const pages_erp_finance_payable_cfo_invoice_outbound_expense = () => import("~/pages/erp/finance/payable/cfo_invoice_outbound_expense")
const pages_erp_finance_payable_cfo_invoice_line_outbound_expense = () => import("~/pages/erp/finance/payable/cfo_invoice_line_outbound_expense")

const pages_erp_finance_account_cfo_invoice= () => import("~/pages/erp/finance/account/cfo_invoice")
const pages_erp_finance_account_cfo_card= () => import("~/pages/erp/finance/account/cfo_card")
const pages_erp_finance_account_cfo_title_move= () => import("~/pages/erp/finance/account/cfo_title_move")
const pages_erp_finance_account_cfo_title_move_line= () => import("~/pages/erp/finance/account/cfo_title_move_line")

const pages_erp_finance_account_cfo_title= () => import("~/pages/erp/finance/account/cfo_title")

const pages_erp_finance_statement_cfo_statement= () => import("~/pages/erp/finance/statement/cfo_statement")
const pages_erp_finance_statement_cfo_statement_write_off_rel= () => import("~/pages/erp/finance/statement/cfo_statement_write_off_rel")
const pages_erp_finance_statement_cfo_statement_invoice_line_rel= () => import("~/pages/erp/finance/statement/cfo_statement_invoice_line_rel")
const pages_info_qcc = () => import("~/pages/info/qcc")
const pages_cart_visit = () => import("~/pages/info/visit")
const pages_cart_api = () => import('~/pages/cart/api')
const pages_info_pushlist = () => import('~/pages/info/pushlist')
const pages_cart_business_desk_line = () => import('~/pages/cart/business_desk_line')
const pages_cart_sku = () => import('~/pages/cart/sku')
const pages_cart_biz_bill = () => import('~/pages/cart/biz_bill')
const preUrl = '/store';
const routes = [
  {
    path: '/',
    component: layout_default,
    redirect: preUrl + '/login',
    children: [
      {
        path: preUrl + '/cart/product',
        component:pages_cart_product
      },
      {
        path: preUrl + '/cart/sku',
        component:pages_cart_sku
      },
      {
        path: preUrl + '/cart/biz_bill',
        component:pages_cart_biz_bill
      },
      {
        path: preUrl + '/cart/price',
        component: pages_cart_price
      },
      {
        path: preUrl + '/cart/business_desk_line',
        component:pages_cart_business_desk_line
      },
      {
        path: preUrl + '/hub/api',
        component:pages_cart_api
      },
      {
        path: preUrl + '/buy/buyer',
        component: pages_buy_buyer
      },
      {
        path: preUrl + '/buy/buyer_detail',
        component: pages_buy_buyer_detail
      },
      {
        path: preUrl + '/buy/cbuyer',
        component: pages_buy_cbuyer
      },
      {
        path: preUrl + '/buy/qfr_line',
        component: pages_buy_qfr_line
      },
      {
        path: preUrl + '/buy/business_link',
        component: pages_buy_business_link
      },
      /*{
        path: preUrl + "/buy/qfr_line_detail",
        component: pages_buy_qfr_line_detail
      },*/
      {
        path: preUrl + '/buy/qfr_list',
        component: pages_buy_qfr_list
      },
      {
        path: preUrl + '/buy/qfr_list_detail',
        component: pages_buy_qfr_list_detail
      },
      {
        path: preUrl + '/buy/rfq_line',
        component: pages_buy_rfq_line
      },
      {
        path: preUrl + '/buy/purchasing_rfq_line',
        component: pages_buy_purchasing_rfq_line
      },
      {
        path: preUrl + '/buy/management_rfq_line',
        component: pages_buy_management_rfq_line
      },
      {
        path: preUrl + '/buy/smart_query',
        component: pages_buy_smart_query
      },
      {
        path: preUrl + '/buy/match_workbench',
        component: pages_buy_match_workbench
      },
      {
        path: preUrl + '/buy/biz_line',
        component: pages_buy_biz_line
      },
      // return 域路由段与后端权限 resource_key 对齐（return_request_line/return_request_detail，与 buy「路由段=权限节点」同约定）；
      // 菜单可见性走默认推导 '/store'+path 命中 store.return.return_request_line，无需 authPath 覆写
      {
        path: preUrl + '/return/return_request_line',
        component: pages_return_return_request_line
      },
      {
        // 路径参数携 id：地址栏不现 ?id=xx（干净 URL）；尾段 id 不在映射表，由 SubNav/TopNav/两 Drawer
        // 四个映射遍历点截断为映射段（startsWith 覆写，同 finance 先例），保证菜单行/高亮/面包屑
        path: preUrl + '/return/return_request_detail/:id',
        component: pages_return_return_request_detail
      },
      {
        path: preUrl + '/cart/biz_line',
        component: pages_cart_biz_line
      },

      /*{
        path: preUrl + "/buy/rfq_line_detail",
        component: pages_buy_rfq_line_detail
      },*/
      {
        path: preUrl + '/buy/rfq_list',
        component: pages_buy_rfq_list
      },
      {
        path: preUrl + '/buy/rfq_list_detail',
        component: pages_buy_rfq_list_detail
      },
      {
        path: preUrl + '/buy/sales_order_list',
        component: pages_buy_sales_order_list
      },
      {
        path: preUrl + '/buy/sales_order_line',
        component: pages_buy_sales_order_line_v1
      },
      {
        path: preUrl + '/buy/sales_match_line',
        component: pages_buy_sales_match_line
      },
      {
        path: preUrl + '/cart/coupon',
        component: pages_cart_coupon
      },
      {
        path: preUrl + '/cart/exchange',
        component: pages_cart_exchange,
        name: 'cart-exchange'
      },
      {
        path: preUrl + '/cart/listings',
        component: pages_cart_listings
      },
      {
        path: preUrl + '/cart/point',
        component: pages_cart_point
      },
      {
        path: preUrl + '/cart/spu',
        component: pages_cart_spu_index
      },
      {
        path: preUrl + '/cart/spu/spu_detail',
        component: pages_cart_spu_spu_detail
      },
      // {
      //   path: preUrl + "/cart/workbench",
      //   component: pages_cart_workbench
      // },
      {
        path: preUrl + '/cart/workbench',
        component: pages_cart_trading_basket
      },
      {
        path: preUrl + '/cart/business_desk',
        component: pages_cart_business_desk
      },
      {
        path: preUrl + '/cart/checkout_account',
        component: pages_cart_checkout_account
      },
      {
        path: preUrl + '/cart/delivery_order',
        component: pages_cart_prompt_account
      },
      {
        path: preUrl + '/cart/advance_order',
        component: pages_cart_advance_account
      },
      {
        path: preUrl + '/cart/order_trail',
        component: pages_cart_order_trail
      },
      {
        path: preUrl + '/info/visit',
        component: pages_cart_visit
      },
      {
        path: preUrl + '/export/match',
        component: pages_export_match
      },
      {
        path: preUrl + '/main',
        component: pages_home_index
      },
      {
        path: preUrl + '/hub/bom',
        component: pages_hub_bom
      },
      {
        path: preUrl + '/hub/history',
        component: pages_hub_history
      },
      {
        path: preUrl + '/hub/history_info',
        component: pages_hub_history_info
      },
      {
        path: preUrl + '/hub/hub',
        component: pages_hub_hub
      },
      {
        path: preUrl + '/hub/match',
        component: pages_hub_match
      },
      {
        path: preUrl + '/hub/result',
        component: pages_hub_result
      },
      {
        path: preUrl + '/hub/upload',
        component: pages_hub_upload
      },
      {
        path: preUrl + '/info/account',
        component: pages_info_account_index
      },
      {
        path: preUrl + '/info/account_contact_detail',
        component: pages_info_account_contact_detail
      },
      {
        path: preUrl + '/info/account_invoice_detail',
        component: pages_info_account_invoice_detail
      },
      {
        path: preUrl + '/info/article',
        component: pages_info_article
      },
      {
        path: preUrl + '/info/attachment',
        component: pages_info_attachment
      },
      {
        path: preUrl + '/info/bank_detail',
        component: pages_info_bank_detail
      },
      {
        path: preUrl + '/info/comment',
        component: pages_info_comment
      },
      {
        path: preUrl + '/info/contact',
        component: pages_info_contact
      },
      {
        path: preUrl + '/info/contact_detail',
        component: pages_info_contact_detail
      },
      {
        path: preUrl + '/info/home',
        component: pages_info_home
      },
      {
        path: preUrl + '/info/invitation',
        component: pages_info_invitation
      },
      {
        path: preUrl + '/info/member',
        component: pages_info_member
      },
      {
        path: preUrl + '/info/partner_shop',
        component: pages_info_partner_shop
      },
      {
        path: preUrl + '/info/collect_shop',
        component: pages_info_collect_shop
      },
      {
        path: preUrl + '/info/folder',
        component: pages_info_folder
      },
      {
        path: preUrl + '/info/account_contact',
        component: pages_info_account_contact
      },
      {
        path: preUrl + '/info/member_detail',
        component: pages_info_member_detail
      },
      {
        path: preUrl + '/info/setting',
        component: pages_info_setting
      },
      {
        path: preUrl + '/info/price_rule',
        component: pages_info_price_rule
      },
      {
        path: preUrl + '/info/profile',
        component: pages_info_profile
      },
      {
        path: preUrl + '/info/dashboard',
        component: pages_info_dashboard
      },
      {
        path: preUrl + '/info/section',
        component: pages_info_section
      },
      {
        path: preUrl + '/info/station',
        component: pages_info_station
      },
      {
        path: preUrl + '/info/station_detail',
        component: pages_info_station_detail
      },
      {
        path: preUrl + '/info/notification',
        component: pages_info_notification
      },
      {
        path: preUrl + '/info/pushlist',
        component: pages_info_pushlist
      },
      {
        path: preUrl + '/info/qichacha',
        component: pages_info_qcc
      },
      {
        path: preUrl + '/login/login',
        component: pages_login_login
      },
      {
        path: preUrl + '/login/retrieve_password',
        component: pages_login_retrieve_password
      },
      {
        path: preUrl + '/order/buy_car',
        component: pages_order_buy_car
      },
      {
        path: preUrl + '/order/sell_car',
        component: pages_order_sell_car
      },
      {
        path: preUrl + '/order/payment',
        component: pages_order_payment
      },
      {
        path: preUrl + '/order/payment_result',
        component: pages_order_payment_result
      },
      {
        path: preUrl + '/order/payment_flow',
        component: pages_order_payment_flow
      },
      {
        path: preUrl + '/order/arbitration',
        component: pages_order_arbitration
      },
      {
        path: preUrl + '/order/sale_bill',
        component: pages_order_sale_bill
      },
      {
        path: preUrl + '/order/sale_item',
        component: pages_order_sale_item
      },
      {
        path: preUrl + '/order/sale_return',
        component: pages_order_sale_return
      },
      {
        path: preUrl + '/finance/receivable/cfo_tax_receipt',
        component: pages_sale_tax_receipt
      },
      {
        path: preUrl + '/finance/receivable/cfo_payment',
        component: pages_cfo_payment
      },
      {
        path: preUrl + '/order/sale_shipping',
        component: pages_sale_shipments
      },
      {
        path: preUrl + '/finance/payable/cfo_tax_receipt_outbound',
        component: pages_purchase_tax_receipt
      },
      {
        path: preUrl + '/finance/payable/cfo_payment_outbound',
        component: pages_cfo_payment_outbound
      },
      {
        path: preUrl + '/order/customer_order',
        component: pages_order_customer_order
      },
      {
        path: preUrl + '/order/purchase_bill',
        component: pages_order_purchase_bill
      },
      {
        path: preUrl + '/order/purchase_item',
        component: pages_order_purchase_item
      },
      {
        path: preUrl + '/order/purchase_return',
        component: pages_order_purchase_return
      },
      {
        path: preUrl + '/order/provider_order',
        component: pages_order_provider_order
      },
      {
        path: preUrl + '/order/sale_deliver',
        component: pages_order_allotment_receipt
      },
      {
        path: preUrl + '/order/purchase_receipts',
        component: pages_order_allotment_receive
      },
      {
        path: preUrl + '/password',
        component: pages_password
      },
      {
        path: preUrl + '/register',
        component: pages_register
      },
      {
        path: preUrl + '/login',
        component: pages_login
      },
      {
        path: preUrl + '/search',
        component: pages_search_index
      },
      {
        path: preUrl + '/sell/avab_line',
        component: pages_sell_avab_line
      },
      /*{
        path: preUrl + "/sell/avab_line_detail",
        component: pages_sell_avab_line_detail
      },*/
      {
        path: preUrl + '/sell/avab_list',
        component: pages_sell_avab_list
      },
      {
        path: preUrl + '/sell/avab_list_detail',
        component: pages_sell_avab_list_detail
      },
      {
        path: preUrl + '/sell/qfa_line',
        component: pages_sell_qfa_line
      },
      /*{
        path: preUrl + "/sell/qfa_line_detail",
        component: pages_sell_qfa_line_detail
      },*/
      {
        path: preUrl + '/sell/qfa_list',
        component: pages_sell_qfa_list
      },
      {
        path: preUrl + '/sell/seller',
        component: pages_sell_seller
      },
      {
        path: preUrl + '/sell/seller_detail',
        component: pages_sell_seller_detail
      },
      {
        path: preUrl + '/sell/sku',
        component: pages_sell_sku
      },
      {
        path: preUrl + '/sell/sku_detail',
        component: pages_sell_sku_detail
      },
      {
        path: preUrl + '/sell/purchase_order_list',
        component: pages_buy_purchase_order_list
      },
      {
        path: preUrl + '/sell/purchase_order_line',
        component: pages_buy_purchase_order_line
      },
      {
        path: preUrl + '/sell/grouping_buy',
        component: pages_buy_grouping_buy
      },
      {
        path: preUrl + '/spu',
        component: pages_spu_index
      },
      {
        path: preUrl + '/spu_list',
        component: pages_spu_list
      },
      {
        path: preUrl + '/spu/spu_detail',
        component: pages_spu_detail
      },
      {
        path: preUrl + '/spu/super_table',
        component: pages_spu_super_table
      },
      {
        path: preUrl + '/member/articles',
        component: pages_user_articles
      },
      {
        path: preUrl + '/member/bind',
        component: pages_user_bind
      },
      {
        path: preUrl + '/member/dashboard',
        component: pages_user_dashboard
      },
      {
        path: preUrl + '/member/info',
        component: pages_user_info
      },
      {
        path: preUrl + '/member/shop',
        component: pages_user_shop
      },
      {
        path: preUrl + '/member/wallet',
        component: pages_user_wallet
      },
      {
        path: preUrl + '/member/notification',
        component: pages_user_notification
      },
      {
        path: preUrl + "/member/activity",
        component: pages_user_activity
      },
      {
        path: preUrl + "/member/account",
        component: pages_info_member_account
      },
      {
        path: preUrl + "/member/contact",
        component: pages_info_contact_single
      },
      {
        path: preUrl + "/member/collect_shop",
        component: pages_info_collect_shop
      },
      {
        path: preUrl + "/member/folder",
        component: pages_info_folder
      },
      {
        path: preUrl + '/member/sound',
        component: pages_user_sound
      },
      {
        path: preUrl + "/cart/buy_sell",
        component: pages_cart_buy_sell
      },
      {
        path: preUrl + "/cart/sell",
        component: pages_cart_sell
      },

      // {
      //   path: preUrl + "/portal/spu",
      //   component: pages_protal_spu
      // },
      // {
      //   path: preUrl + "/portal/brand",
      //   component: pages_protal_brand
      // },
      // {
      //   path: preUrl + "/portal/category",
      //   component: pages_protal_category
      // },
      // {
      //   path: preUrl + "/portal/content",
      //   component: pages_protal_content
      // },
    ]
  },
  {
    path: '/erp',
    redirect: '/erp/staff/dashboard',
    component: layout_admin,
    children: [
      {
        path: '/erp/account/account/legal_entity',
        component: pages_erp_accouting_legalEntity
      },
      {
        path: '/erp/account/account/main',
        component: pages_erp_account_account_main
      },
      {
        path: '/erp/account/account/buyer',
        component: pages_erp_account_account_buyer
      },
      {
        path: '/erp/account/account/finance',
        component: pages_erp_account_account_finance
      },
      {
        path: '/erp/account/account/info',
        component: pages_erp_account_account_info
      },
      {
        path: '/erp/account/account/management',
        component: pages_erp_account_account_management
      },
      {
        path: '/erp/account/account/recycle',
        component: pages_erp_account_account_recycle
      },
      {
        path: '/erp/account/account/appointment',
        component: pages_erp_account_account_appointment
      },
      {
        path: '/erp/account/account/seller',
        component: pages_erp_account_account_seller
      },
      {
        path: '/erp/account/agreement/signature',
        component: pages_erp_account_agreement_signature
      },
      {
        path: '/erp/account/agreement/version',
        component: pages_erp_account_agreement_version
      },
      {
        path: '/erp/account/bank/account',
        component: pages_erp_account_bank_account
      },
      {
        path: '/erp/account/bank/bank_account',
        component: pages_erp_account_bank_bank_account
      },

      {
        path: '/erp/account/bank/info',
        component: pages_erp_account_bank_info
      },
      {
        path: '/erp/account/bank/bank',
        component: pages_erp_account_bank_bank
      },
      {
        path: '/erp/account/contact/info',
        component: pages_erp_account_contact_info
      },
      {
        path: '/erp/account/contact/member',
        component: pages_erp_account_contact_member
      },
      {
        path: '/erp/account/credit/info',
        component: pages_erp_account_credit_info
      },
      {
        path: '/erp/account/credit/manage',
        component: pages_erp_account_credit_manage
      },
      {
        path: '/erp/account/credit/verification',
        component: pages_erp_account_credit_verification
      },
      {
        path: '/erp/account/invoice/info',
        component: pages_erp_account_invoice_info
      },
      {
        path: '/erp/account/invoice/tax',
        component: pages_erp_account_invoice_tax
      },
      {
        path: '/erp/accouting/account/analysis',
        component: pages_erp_accouting_account_analysis
      },
      {
        path: '/erp/accouting/account/code',
        component: pages_erp_accouting_account_code
      },
      {
        path: '/erp/accouting/bill/ledger',
        component: pages_erp_accouting_bill_ledger
      },
      {
        path: '/erp/accouting/bill/payable',
        component: pages_erp_accouting_bill_payable
      },
      {
        path: '/erp/accouting/bill/receivable',
        component: pages_erp_accouting_bill_receivable
      },
      {
        path: '/erp/accouting/order/purchasing/line',
        component: pages_erp_accouting_order_purchasing_line
      },
      {
        path: '/erp/accouting/order/purchasing/po',
        component: pages_erp_accouting_order_purchasing_po
      },
      {
        path: '/erp/accouting/order/purchasing/prma',
        component: pages_erp_accouting_order_purchasing_prma
      },
      {
        path: '/erp/accouting/order/sales/line',
        component: pages_erp_accouting_order_sales_line
      },
      {
        path: '/erp/accouting/order/sales/so',
        component: pages_erp_accouting_order_sales_so
      },
      {
        path: '/erp/accouting/order/sales/srma',
        component: pages_erp_accouting_order_sales_srma
      },
      {
        path: '/erp/accouting/payment/incoming',
        component: pages_erp_accouting_payment_incoming
      },
      {
        path: '/erp/accouting/payment/outgoing',
        component: pages_erp_accouting_payment_outgoing
      },
      {
        path: '/erp/accouting/report',
        component: pages_erp_accouting_report_index
      },
      {
        path: '/erp/accouting/tax/input',
        component: pages_erp_accouting_tax_input
      },
      {
        path: '/erp/accouting/tax/output',
        component: pages_erp_accouting_tax_output
      },
      {
        path: '/erp/credit/contact/contactperson',
        component: pages_erp_credit_contact_contactperson_index
      },
      {
        path: '/erp/credit/contact',
        component: pages_erp_credit_contact_index
      },
      {
        path: '/erp/credit/contact/info',
        component: pages_erp_credit_contact_info
      },
      {
        path: '/erp/credit/contact/legalperson',
        component: pages_erp_credit_contact_legalperson_index
      },
      {
        path: '/erp/credit/contact/naturalperson',
        component: pages_erp_credit_contact_naturalperson_index
      },
      {
        path: '/erp/credit/contact/relationship',
        component: pages_erp_credit_contact_relationship
      },
      {
        path: '/erp/credit/contact/shop',
        component: pages_erp_credit_contact_shop_index
      },
      {
        path: '/erp/credit/contact/user',
        component: pages_erp_credit_contact_user_index
      },
      {
        path: '/erp/credit/credit/info',
        component: pages_erp_credit_credit_info
      },
      {
        path: '/erp/credit/credit/verification',
        component: pages_erp_credit_credit_verification
      },
      {
        path: '/erp/credit/legal/certificate',
        component: pages_erp_credit_legal_certificate
      },
      {
        path: '/erp/credit/legal/info',
        component: pages_erp_credit_legal_info
      },
      {
        path: '/erp/credit/natural/certificate',
        component: pages_erp_credit_natural_certificate
      },
      {
        path: '/erp/credit/natural/experience',
        component: pages_erp_credit_natural_experience
      },
      {
        path: '/erp/credit/natural/info',
        component: pages_erp_credit_natural_info
      },
      {
        path: '/erp/index',
        component: pages_erp_index
      },
      {
        path: '/erp/market/activity',
        component: pages_erp_market_activity
      },
      {
        path: '/erp/market/contact/contactperson',
        component: pages_erp_market_contact_contactperson_index
      },
      {
        path: '/erp/market/contact',
        component: pages_erp_market_contact_index
      },
      {
        path: '/erp/market/contact/info',
        component: pages_erp_market_contact_info
      },
      {
        path: '/erp/market/contact/legalperson',
        component: pages_erp_market_contact_legalperson_index
      },
      {
        path: '/erp/market/contact/naturalperson',
        component: pages_erp_market_contact_naturalperson_index
      },
      {
        path: '/erp/market/contact/relationship',
        component: pages_erp_market_contact_relationship
      },
      {
        path: '/erp/market/contact/shop',
        component: pages_erp_market_contact_shop_index
      },
      {
        path: '/erp/market/contact/user',
        component: pages_erp_market_contact_user_index
      },
      {
        path: '/erp/market/content',
        component: pages_erp_market_content
      },
      {
        path: '/erp/market/credit/info',
        component: pages_erp_market_credit_info
      },
      {
        path: '/erp/market/credit/verification',
        component: pages_erp_market_credit_verification
      },
      {
        path: '/erp/market/invite',
        component: pages_erp_market_invite
      },
      {
        path: '/erp/market/legal/certificate',
        component: pages_erp_market_legal_certificate
      },
      {
        path: '/erp/market/legal/info',
        component: pages_erp_market_legal_info
      },
      {
        path: '/erp/market/natural/certificate',
        component: pages_erp_market_natural_certificate
      },
      {
        path: '/erp/market/natural/experience',
        component: pages_erp_market_natural_experience
      },
      {
        path: '/erp/market/natural/info',
        component: pages_erp_market_natural_info
      },
      {
        path: '/erp/operation/attendance',
        component: pages_erp_operation_attendance
      },
      {
        path: '/erp/operation/budget',
        component: pages_erp_operation_budget
      },
      {
        path: '/erp/operation/department',
        component: pages_erp_operation_department
      },
      {
        path: '/erp/operation/employee',
        component: pages_erp_operation_employee
      },
      {
        path: '/erp/operation/job',
        component: pages_erp_operation_job
      },
      {
        path: '/erp/operation/kpi',
        component: pages_erp_operation_kpi
      },
      {
        path: '/erp/operation/policy',
        component: pages_erp_operation_policy
      },
      {
        path: '/erp/operation/position',
        component: pages_erp_operation_position
      },
      {
        path: '/erp/operation/report',
        component: pages_erp_operation_report
      },
      {
        path: '/erp/operation/salary',
        component: pages_erp_operation_salary
      },
      {
        path: '/erp/portal/business',
        component: pages_erp_portal_business
      },
      {
        path: '/erp/portal/contract',
        component: pages_erp_portal_contract
      },
      {
        path: '/erp/portal/data',
        component: pages_erp_portal_data
      },
      {
        path: '/erp/portal/external_partner',
        component: pages_erp_portal_external_partner
      },
      {
        path: '/erp/portal/grant/position',
        component: pages_erp_portal_grant_position
      },
      {
        path: '/erp/portal/grant/privilege',
        component: pages_erp_portal_grant_privilege
      },
      {
        path: "/erp/portal/grant/default_station",
        component: pages_erp_portal_grant_default_station
      },
      {
        path: "/erp/portal/organization/sbu",
        component: pages_erp_portal_organization_department
      },
      {
        path: "/erp/portal/organization/job",
        component: pages_erp_portal_organization_station
      },
      {
        path: "/erp/portal/organization/appoint",
        component: pages_erp_portal_organization_appoint
      },
      {
        path: "/erp/portal/internal_partner",
        component: pages_erp_portal_internal_partner
      },
      {
        path: '/erp/portal/manage',
        component: pages_erp_portal_manage
      },
      {
        path: '/erp/portal/quota',
        component: pages_erp_portal_quota
      },
      {
        path: '/erp/portal/service',
        component: pages_erp_portal_service
      },
      {
        path: '/erp/portal/settlement',
        component: pages_erp_portal_settlement
      },
      {
        path: '/erp/service/shop',
        component: pages_erp_service_shop_index
      },
      {
        path: '/erp/portal/shop/management/detail',
        component: pages_erp_portal_shop_management_detail
      },
      {
        path: '/erp/portal/shop/management',
        component: pages_erp_portal_shop_management_index
      },
      {
        path: '/erp/portal/shop/member/detail',
        component: pages_erp_portal_shop_member_detail
      },
      {
        path: '/erp/portal/shop/member',
        component: pages_erp_portal_shop_member_index
      },
      {
        path: '/erp/portal/shop/register/detail',
        component: pages_erp_portal_shop_register_detail
      },
      {
        path: '/erp/portal/shop/register',
        component: pages_erp_portal_shop_register_index
      },
      {
        path: '/erp/portal/tenant',
        component: pages_erp_portal_tenant
      },
      {
        path: '/erp/portal/user/management/detail',
        component: pages_erp_portal_user_management_detail
      },
      {
        path: '/erp/portal/user/management',
        component: pages_erp_portal_user_management_index
      },
      {
        path: '/erp/portal/user/register',
        component: pages_erp_portal_user_register_index
      },
      {
        path: '/erp/portal/website',
        component: pages_erp_portal_website
      },
      {
        path: '/erp/portal/whitepaper',
        component: pages_erp_portal_whitepaper
      },
      {
        path: '/erp/product/attribute/attribute',
        component: pages_erp_product_attribute_attribute
      },
      {
        path: '/erp/product/attribute/eccn',
        component: pages_erp_product_attribute_eccn
      },

      {
        path: '/erp/product/attribute/hscode',
        component: pages_erp_product_attribute_hscode
      },
      {
        path: '/erp/product/attribute/info',
        component: pages_erp_product_attribute_info
      },
      {
        path: '/erp/product/attribute/package',
        component: pages_erp_product_attribute_package
      },
      {
        path: '/erp/product/brand/authorization',
        component: pages_erp_product_brand_authorization
      },
      {
        path: '/erp/product/brand/business_report',
        component: pages_erp_product_brand_business_report
      },
      {
        path: '/erp/product/brand/info',
        component: pages_erp_product_brand_info
      },
      {
        path: '/erp/product/brand/info_report',
        component: pages_erp_product_brand_info_report
      },
      {
        path: '/erp/product/brand/management',
        component: pages_erp_product_brand_management
      },
      {
        path: '/erp/product/category/business_report',
        component: pages_erp_product_category_business_report
      },
      {
        path: '/erp/product/category/info',
        component: pages_erp_product_category_info
      },
      {
        path: '/erp/product/category/info_report',
        component: pages_erp_product_category_info_report
      },
      {
        path: '/erp/product/category/management',
        component: pages_erp_product_category_management
      },
      {
        path: '/erp/product/price/cost',
        component: pages_erp_product_price_cost
      },
      {
        path: '/erp/product/price/listpriceline',
        component: pages_erp_product_price_listpriceline
      },
      {
        path: '/erp/product/price/list_price',
        component: pages_erp_product_price_list_price
      },
      {
        path: '/erp/product/price/policy',
        component: pages_erp_product_price_policy
      },
      {
        path: '/erp/product/price/price_list',
        component: pages_erp_product_price_price_list
      },
      {
        path: '/erp/product/price/price_rule',
        component: pages_erp_product_price_price_rule
      },
      {
        path: '/erp/product/price/quote',
        component: pages_erp_product_price_quote
      },
      {
        path: '/erp/product/report',
        component: pages_erp_product_report_index
      },
      {
        path: '/erp/product/specification/code',
        component: pages_erp_product_specification_code
      },
      {
        path: '/erp/product/specification/detail',
        component: pages_erp_product_specification_detail
      },
      {
        path: '/erp/product/specification/info',
        component: pages_erp_product_specification_info
      },
      {
        path: '/erp/product/specification/report',
        component: pages_erp_product_specification_report
      },
      {
        path: '/erp/product/specification/sku',
        component: pages_erp_product_specification_sku
      },
      {
        path: '/erp/product/spu/business_report',
        component: pages_erp_product_spu_business_report
      },
      {
        path: '/erp/product/spu/info',
        component: pages_erp_product_spu_info
      },
      {
        path: '/erp/product/spu/info_report',
        component: pages_erp_product_spu_info_report
      },
      {
        path: '/erp/product/spu/management',
        component: pages_erp_product_spu_management
      },
      {
        path: '/erp/product/price/management',
        component: pages_erp_product_spu_qualified_vendor_management
      },
      {
        path: '/erp/product/price/shopspu',
        component: pages_erp_product_spu_qualified_vendor_shopspu
      },
      {
        path: '/erp/product/price/brandlist',
        component: pages_erp_product_spu_qualified_vendor_brandlist
      },
      {
        path: '/erp/product/workbench',
        component: pages_erp_product_workbench_index
      },
      {
        path: '/erp/product/product/apl',
        component: pages_erp_product_product_apl
      },

      {
        path: '/erp/service/activity',
        component: pages_erp_service_activity
      },
      {
        path: '/erp/service/arrachments',
        component: pages_erp_service_arrachments_index
      },
      {
        path: '/erp/service/chat',
        component: pages_erp_service_chat
      },
      {
        path: '/erp/service/comments',
        component: pages_erp_service_comments_index
      },
      {
        path: '/erp/service/currency',
        component: pages_erp_service_currency
      },
      {
        path: '/erp/service/keyword',
        component: pages_erp_service_keyword
      },
      {
        path: '/erp/staff/dashboard',
        component: pages_erp_staff_dashboard_index
      },
      {
        path: '/erp/service/indexer/dictionary',
        component: pages_erp_service_dictionary
      },
      {
        path: '/erp/service/indexer/indexer',
        component: pages_erp_service_indexer
      },
      {
        path: '/erp/service/indexer/entity',
        component: pages_erp_service_entity
      },
      {
        path: '/erp/service/indexer/field',
        component: pages_erp_service_field
      },
      {
        path: "/erp/service/indexer/region",
        component: pages_erp_service_region
      },
      {
        path: "/erp/service/indexer/interface",
        component: pages_erp_service_interface
      },
      {
        path: "/erp/service/indexer/word",
        component: pages_erp_service_word
      },
      {
        path: '/erp/service/favorites',
        component: pages_erp_service_favorites_index
      },
      {
        path: '/erp/service/language',
        component: pages_erp_service_language
      },
      {
        path: '/erp/service/list_mapping/column',
        component: pages_erp_service_list_mapping_column
      },
      {
        path: '/erp/service/list_mapping/field',
        component: pages_erp_service_list_mapping_field
      },
      {
        path: '/erp/service/mapping/account',
        component: pages_erp_service_mapping_account
      },
      {
        path: '/erp/service/mapping/interchange',
        component: pages_erp_service_mapping_interchange
      },
      {
        path: '/erp/service/mapping/monitor',
        component: pages_erp_service_mapping_monitor
      },
      {
        path: '/erp/service/ratings',
        component: pages_erp_service_ratings_index
      },
      {
        path: '/erp/service/remark',
        component: pages_erp_service_remark
      },
      {
        path: '/erp/service/tag',
        component: pages_erp_service_tag
      },
      {
        path: '/erp/service/tags',
        component: pages_erp_service_tags_index
      },
      {
        path: '/erp/service/tax',
        component: pages_erp_service_tax
      },
      {
        path: '/erp/service/reporting/metrics',
        component: pages_erp_service_reporting_metrics_index
      },
      {
        path: '/erp/service/reporting/dimension',
        component: pages_erp_service_reporting_dimension_index
      },
      {
        path: '/erp/service/reporting/kpi',
        component: pages_erp_service_reporting_kpi_index
      },
      {
        path: '/erp/service/reporting/dashboard',
        component: pages_erp_service_reporting_dashboard_index
      },
      {
        path: '/erp/service/services_item',
        component: pages_erp_service_services_item_index
      },
      {
        path: '/erp/service/time_zone',
        component: pages_erp_service_time_zone
      },
      {
        path: '/erp/service/manage/print',
        component: pages_erp_service_manage_print
      },
      {
        path: '/erp/service/manage/api',
        component: pages_erp_service_manage_api
      },
      {
        path: '/erp/service/manage/access',
        component: pages_erp_service_manage_access
      },
      {
        path: '/erp/service/manage/site',
        component: pages_erp_service_manage_site
      },
      {
        path: '/erp/service/manage/menu_template',
        component: pages_erp_service_manage_menu
      },
      {
        path: '/erp/service/manage/site_template',
        component: pages_erp_service_manage_site_template
      },
      {
        path: '/erp/service/manage/domain',
        component: pages_erp_service_manage_domain
      },
      {
        path:  '/erp/service/engine/rule',
        component: pages_erp_service_engine_rule
      },
      {
        path: '/erp/service/engine/policy',
        component: pages_erp_service_engine_policy
      },
      {
        path: '/erp/shipping/customs_declaration',
        component: pages_erp_shipping_customs_declaration
      },
      {
        path: '/erp/shipping/packing_list',
        component: pages_erp_shipping_packing_list
      },
      {
        path: '/erp/shipping/qc',
        component: pages_erp_shipping_qc
      },
      {
        path: '/erp/shipping/report',
        component: pages_erp_shipping_report
      },
      {
        path: '/erp/shipping/sort',
        component: pages_erp_shipping_sort
      },
      {
        path: '/erp/shipping/test_sheet',
        component: pages_erp_shipping_test_sheet
      },
      {
        path: '/erp/shipping/warehouse',
        component: pages_erp_shipping_warehouse
      },
      {
        path: '/erp/shipping/warehouse_receipt',
        component: pages_erp_shipping_warehouse_receipt
      },
      {
        path: '/erp/shipping/waybill',
        component: pages_erp_shipping_waybill
      },
      {
        path: '/erp/account/account/user',
        component: pages_erp_account_user
      },
      {
        path: '/erp/account/account/shop',
        component: pages_erp_account_shop
      },
      {
        path: "/erp/logistics/picking/order",
        component: pages_erp_logistics_order
      },
      {
        path: "/erp/logistics/picking/order_line",
        component: pages_erp_logistics_order_line
      },
      {
        path: "/erp/logistics/picking/receipt",
        component: pages_erp_logistics_receipt
      },
      {
        path: "/erp/logistics/picking/receipt_line",
        component: pages_erp_logistics_receipt_line
      },
      {
        path: "/erp/logistics/picking/put_in_storage",
        component: pages_erp_logistics_put_in_storage
      },
      {
        path: "/erp/logistics/picking/put_in_storage_line",
        component: pages_erp_logistics_put_in_storage_line
      },
      {
        path: "/erp/logistics/picking/ex_warehouse",
        component: pages_erp_logistics_ex_warehouse
      },
      {
        path: "/erp/logistics/picking/ex_warehouse_line",
        component: pages_erp_logistics_ex_warehouse_line
      },
      {
        path: "/erp/logistics/picking/shipments",
        component: pages_erp_logistics_shipments
      },
      {
        path: "/erp/logistics/picking/shipments_line",
        component: pages_erp_logistics_shipments_line
      },
      {
        path: "/erp/logistics/picking/service_line",
        component: pages_erp_logistics_service_line
      },
      {
        path: "/erp/logistics/transport/waybill",
        component: pages_erp_logistics_waybill
      },
      {
        path: "/erp/logistics/transport/packing_list",
        component: pages_erp_logistics_packing_list
      },
      {
        path: "/erp/logistics/transport/packing_item",
        component: pages_erp_logistics_packing_item
      },
      {
        path: "/erp/logistics/transport/tariff",
        component: pages_erp_logistics_tariff
      },
      {
        path: "/erp/logistics/transport/tariff_line",
        component: pages_erp_logistics_tariff_line
      },
      {
        path: "/erp/logistics/transport/carriers",
        component: pages_erp_logistics_carriers
      },
      {
        path: "/erp/logistics/transport/shipping_method",
        component: pages_erp_logistics_shipping_method
      },
      {
        path: "/erp/logistics/transport/tariff_filing",
        component: pages_erp_logistics_tariff_filing
      },
      {
        path: "/erp/logistics/quality/qc_test",
        component: pages_erp_logistics_quality_qc_test
      },
      {
        path: "/erp/logistics/quality/qc_report",
        component: pages_erp_logistics_quality_qc_report
      },
      {
        path: "/erp/logistics/quality/qc_categ",
        component: pages_erp_logistics_quality_qc_categ
      },
      {
        path: "/erp/logistics/quality/qc_rule",
        component: pages_erp_logistics_quality_qc_rule
      },
      {
        path: "/erp/logistics/quality/qc_sample",
        component: pages_erp_logistics_quality_qc_sample
      },
      {
        path: "/erp/logistics/store_keeper/moving",
        component: pages_erp_logistics_store_keeper_moving
      },
      {
        path: "/erp/logistics/store_keeper/moving_line",
        component: pages_erp_logistics_store_keeper_moving_line
      },
      {
        path: "/erp/logistics/store_keeper/stock_check",
        component: pages_erp_logistics_store_keeper_stock_check
      },
      {
        path: "/erp/logistics/store_keeper/stock_check_line",
        component: pages_erp_logistics_store_keeper_stock_check_line
      },
      {
        path: "/erp/logistics/warehousing/stock",
        component: pages_erp_logistics_warehousing_stock
      },
      {
        path: "/erp/logistics/warehousing/stock_line",
        component: pages_erp_logistics_warehousing_stock_line
      },
      {
        path: "/erp/logistics/warehousing/warehouse_receipt",
        component: pages_erp_logistics_warehousing_warehouse_receipt
      },
      {
        path: "/erp/logistics/warehousing/warehouse_receipt_item",
        component: pages_erp_logistics_warehousing_warehouse_receipt_item
      },
      {
        path: "/erp/logistics/warehousing/scheduling",
        component: pages_erp_logistics_warehousing_scheduling
      },
      {
        path: "/erp/logistics/warehousing/packing_box",
        component: pages_erp_logistics_warehousing_packing_box
      },
      {
        path: "/erp/logistics/warehousing/packaging",
        component: pages_erp_logistics_warehousing_packaging
      },
      {
        path: "/erp/logistics/reservoir_area/warehouse",
        component: pages_erp_logistics_reservoir_area_warehouse
      },
      {
        path: "/erp/logistics/reservoir_area/section",
        component: pages_erp_logistics_reservoir_area_section
      },
      {
        path: "/erp/logistics/reservoir_area/lot",
        component: pages_erp_logistics_reservoir_area_lot
      },
      {
        path: "/erp/logistics/reservoir_area/tracking_no",
        component: pages_erp_logistics_tracking_no
      },
      {
        path: "/erp/logistics/reservoir_area/layout",
        component: pages_erp_logistics_layout
      },
      {
        path: "/erp/logistics/reservoir_area/channel",
        component: pages_erp_logistics_channel
      },
      {
        path: "/erp/logistics/reservoir_area/path",
        component: pages_erp_logistics_path
      },
      {
        path: "/erp/logistics/reservoir_area/type",
        component: pages_erp_logistics_type
      },
      {
        path: "/erp/logistics/management/tenement",
        component: pages_erp_logistics_tenement
      },
      {
        path: "/erp/logistics/management/connected_group",
        component: pages_erp_logistics_connected_group
      },
      {
        path: "/erp/logistics/management/traders",
        component: pages_erp_logistics_traders
      },
      {
        path: "/erp/logistics/management/contacts",
        component: pages_erp_logistics_contacts
      },
      {
        path: "/erp/logistics/management/work_order",
        component: pages_erp_logistics_work_order
      },
      {
        path: "/erp/logistics/management/work_order_item",
        component: pages_erp_logistics_work_order_item
      },
      {
        path: "/erp/logistics/management/expense",
        component: pages_erp_logistics_expense
      },
      {
        path: "/erp/logistics/management/expense_item",
        component: pages_erp_logistics_expense_item
      },
      {
        path: '/erp/product/product/brand',
        component: pages_erp_product_product_brand
      },
      {
        path: '/erp/product/product/spu',
        component: pages_erp_product_product_spu
      },
      {
        path: '/erp/product/product/brand_report',
        component: pages_erp_product_product_brand_report
      },
      {
        path: '/erp/product/product/spu_report',
        component: pages_erp_product_product_spu_report
      },
      {
        path: '/erp/product/product/fmt',
        component: pages_erp_product_product_fmt
      },
      {
        path: '/erp/product/product/detail',
        component: pages_erp_product_product_detail
      },
      {
        path: '/erp/product/product/attribute',
        component: pages_erp_product_product_attribute
      },
      {
        path: '/erp/product/product/eccn',
        component: pages_erp_product_product_eccn
      },
      {
        path: '/erp/product/product/hscode',
        component: pages_erp_product_product_hscode
      },
      {
        path: '/erp/product/product/category',
        component: pages_erp_product_product_category
      },
      {
        path: '/erp/product/product/package',
        component: pages_erp_product_product_package
      },

      {
        path: '/erp/finance/payable/vendor',
        component: pages_erp_finance_payable_vendor
      },
      {
        path: "/erp/finance/payable/cfo_invoice_outbound",
        component: pages_erp_finance_payable_cfo_invoice_outbound
      },
      {
        path: "/erp/finance/payable/cfo_invoice_line_outbound",
        component: pages_erp_finance_payable_cfo_invoice_line_outbound
      },
      {
        path: "/erp/finance/payable/cfo_payment_outbound",
        component: pages_erp_finance_payable_cfo_payment_outbound
      },
      {
        path: "/erp/finance/payable/cfo_write_off_outbound",
        component: pages_erp_finance_payable_cfo_write_off_outbound
      },
      {
        path: "/erp/finance/payable/cfo_tax_receipt_outbound",
        component: pages_erp_finance_payable_cfo_tax_receipt_outbound
      },
      {
        path: "/erp/finance/payable/cfo_tax_receipt_line_outbound",
        component: pages_erp_finance_payable_cfo_tax_receipt_line_outbound
      },
      {
        path: "/erp/finance/payable/cfo_invoice_outbound_expense",
        component: pages_erp_finance_payable_cfo_invoice_outbound_expense
      },
      {
        path: "/erp/finance/payable/cfo_invoice_line_outbound_expense",
        component: pages_erp_finance_payable_cfo_invoice_line_outbound_expense
      },
      {
        path: "/erp/finance/receivable/customer",
        component: pages_erp_finance_receivable_customer
      },
      {
        path: "/erp/finance/receivable/cfo_invoice_line",
        component: pages_erp_finance_receivable_cfo_invoice_line
      },
      {
        path: "/erp/finance/receivable/cfo_invoice",
        component: pages_erp_finance_receivable_cfo_invoice
      },
      {
        path: "/erp/finance/receivable/cfo_payment",
        component: pages_erp_finance_receivable_cfo_payment
      },
      {
        path: "/erp/finance/receivable/cfo_write_off",
        component: pages_erp_finance_receivable_cfo_write_off
      },
      {
        path: "/erp/finance/receivable/cfo_tax_receipt",
        component: pages_erp_finance_receivable_cfo_tax_receipt
      },
      {
        path: "/erp/finance/receivable/cfo_tax_receipt_line",
        component: pages_erp_finance_receivable_cfo_tax_receipt_line
      },
      {
        path: "/erp/finance/receivable/cfo_invoice_expense",
        component: pages_erp_finance_receivable_cfo_invoice_expense
      },
      {
        path: "/erp/finance/receivable/cfo_invoice_line_expense",
        component: pages_erp_finance_receivable_cfo_invoice_line_expense
      },
      {
        path: "/erp/finance/account/cfo_invoice",
        component: pages_erp_finance_account_cfo_invoice
      },
      {
        path: "/erp/finance/account/cfo_card",
        component: pages_erp_finance_account_cfo_card
      },
      {
        path: "/erp/finance/account/cfo_title_move",
        component: pages_erp_finance_account_cfo_title_move
      },
      {
        path: "/erp/finance/account/cfo_title_move_line",
        component: pages_erp_finance_account_cfo_title_move_line
      },
      {
        path: "/erp/finance/account/cfo_title",
        component: pages_erp_finance_account_cfo_title
      },
      {
        path: "/erp/service/history",
        component: pages_erp_service_history_index
      },
      {
        path: "/erp/finance/statement/cfo_statement",
        component: pages_erp_finance_statement_cfo_statement
      },
      {
        path: "/erp/finance/statement/cfo_statement_write_off_rel",
        component: pages_erp_finance_statement_cfo_statement_write_off_rel
      },
      {
        path: "/erp/finance/statement/cfo_statement_invoice_line_rel",
        component: pages_erp_finance_statement_cfo_statement_invoice_line_rel
      },
      {
        path: preUrl + "/work-board",
        component: pages_work_board_index,
        name: "work-board"
      }
    ]
  }
];
export default routes;
